import apiClient from './client';

export async function login(payload) {
  const response = await apiClient.post('/auth/login', payload);
  return response.data;
}

export async function register(payload) {
  const response = await apiClient.post('/auth/register', payload);
  return response.data;
}

export async function getProfile() {
  const response = await apiClient.get('/auth/profile');
  return response.data;
}

export async function updateProfile(payload) {
  const response = await apiClient.put('/auth/profile', payload);
  return response.data;
}

export async function changePassword(payload) {
  const response = await apiClient.put('/auth/password', payload);
  return response.data;
}
